<template>
  <div class="demo">
    <van-button type="primary" @click="gominWechat">主要按钮</van-button>
  </div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon } from 'vant';
  export default {
    data () {
      return {
        img:{
          approve: require('../../../assets/img/lexus/member/approceing.png')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })

    },
    methods: {
      gominWechat(){
        wx.miniProgram.reLaunch({url: '/pages/index/index'})
      }
    },
    components: {
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [Field.name]:Field,
      [Button.name]:Button,
      [Icon.name]:Icon
    }
  }
</script>
<style lang="scss">
.demo{

}
</style>
